import { render, staticRenderFns } from "./FormTextAreaVisionTab3.vue?vue&type=template&id=3faa4301&scoped=true"
import script from "./FormTextAreaVisionTab3.vue?vue&type=script&lang=js"
export * from "./FormTextAreaVisionTab3.vue?vue&type=script&lang=js"
import style0 from "./FormTextAreaVisionTab3.vue?vue&type=style&index=0&id=3faa4301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa4301",
  null
  
)

export default component.exports